import { createSlice } from "@reduxjs/toolkit";

export const homeSlice = createSlice({
  name: "home",
  initialState: {
    toggleTitle: "Bike", // UI-related state
  },
  reducers: {
    setToggleTitle: (state, action) => {
      state.toggleTitle = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setToggleTitle } = homeSlice.actions;

export default homeSlice.reducer;
